








import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import MpCard from '@/components/controls/mp-card/MpCard.vue';
import MpVideoPlayer from '@/components/controls/mp-video-player/MpVideoPlayer.vue';
@Component({
  components: { MpVideoPlayer, MpCard }
})
export default class MpModalVideoPlayer extends Vue {
  @Prop()
  value!: boolean;

  @Prop()
  videoUrl!: string;

  @Prop()
  videoPoster!: string;

  showDialog: boolean = false;

  $refs: any = {
    videoPlayer: MpVideoPlayer
  };

  @Watch('value')
  onValueChanged(v: boolean) {
    this.showDialog = v;
  }

  @Watch('showDialog')
  onShowDialogChanged(v: boolean) {
    this.$emit('input', v);

    if (!v) {
      this.$refs.videoPlayer.pause();
    }
  }

  mounted() {
    this.showDialog = this.value;
  }
}
